const request = {
    invalid_input: 'La entrada no es válida. {{detalles}}',
    general: 'Ocurrió un error en la solicitud.',
};
export default Object.freeze(request);
